import { FracFleetBase } from './base/frac-fleet-base';

export class FracFleet extends FracFleetBase { }